export const getContent = (prismicContent: any): Record<string, unknown> => prismicContent?.results[0] || []

const contentGetters = {
  getContent
}

export default contentGetters
